(function() {
    'use strict';

    angular.module('user')
        .controller('AdminCreateController', AdminCreateController);

    AdminCreateController.$inject = [
        '$state',
        'adminDataSrvc',
        'notificationSrvc',
        'adminMessagesConst',
        'modelPermissionsGroupDataSrvc',
        'competenceDataSrvc',
        'machineActionsDataSrvc',
        'errorNotificationSrvc',
        'userStorageSrvc'
    ];

    function AdminCreateController(
        $state, adminDataSrvc, notificationSrvc, adminMessagesConst, modelPermissionsGroupDataSrvc, competenceDataSrvc,
        machineActionsDataSrvc, errorNotificationSrvc, userStorageSrvc
    ) {
        var self = this;
        self.loggedUser = userStorageSrvc.getUser();

        self.serverErrors = {
            user: {
                username: [],
                password: [],
                email: [],
                first_name: [],
                last_name: [],
                groups: [],
                is_active: [],
                is_superuser: []
            },
            competencies: [],
            machine_actions: [],
            nonFieldErrors: []
        };
        self.adminData = {
            user: {
                username: '',
                password: '',
                email: '',
                first_name: '',
                last_name: '',
                groups: [],
                is_active: false,
            },
            competencies: [],
            machine_actions: [],
        };
        self.groupList = [];
        self.competencies = [];
        self.machineActions = [];

        self.createAdmin = createAdmin;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getModelPermissionsGroup();
            getCompetencies();
            getMachines();
        }

        function getModelPermissionsGroup() {
            return modelPermissionsGroupDataSrvc.adminList()
                .$promise.then(
                    function(response) {
                        self.groupList = response;
                        return response;
                    }
                );
        }

        function getCompetencies() {
            return competenceDataSrvc.adminList().$promise.then(
                function(response) {
                    self.competencies = response;
                    return response;
                }
            );
        }

        function getMachines() {
            return machineActionsDataSrvc.adminList().$promise.then(
                function(response) {
                    self.machineActions = response;
                    return response;
                }
            );
        }

        function createAdmin() {
            adminDataSrvc.create(
                self.adminData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", adminMessagesConst.add);
                    $state.go('layout.admin.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(errorField, key) {
            errorField[key] = [];
        }
    }
})();
